(() => {
  const AllUnderWearItemsInCart = (cart) => {
    let underWearTotalItems = cart.items.filter((item) => {
      return item.product_type == 'Underwear';
    });
    var totalIDs = [], propertiesItem = [];
    var underWearTotalItemsCount = underWearTotalItems.reduce((sum, item) => sum + item.quantity, 0);
    underWearTotalItems.filter(function(item, index){
      totalIDs.push(item.id)
      propertiesItem.push(item.properties);
    })
    return {
      items: underWearTotalItems,
      count: underWearTotalItemsCount,
      Id : totalIDs,
      line_properties : propertiesItem,
    };
  }

  const GetUnderWearItemsInCart = (cart) => {
    let underWearItems = cart.items.filter((item) => {
      return item.product_id == 11509598279 || item.product_id == 11510437255 || item.product_id == 7153610850413 || item.product_id == 7153610784877;
    });

    var underWearItemsCount = underWearItems.reduce((sum, item) => sum + item.quantity, 0);

    return {
      items: underWearItems,
      count: underWearItemsCount
    };
  }

  const GetLongShortItemsInCart = (cart) => {
    let LongShortsItems = cart.items.filter((item) => {
      return item.product_id == 4322199634029 || item.product_id == 7015495762029 || item.product_id == 7156589396077;
    });

    var LongShortsItemsCount = LongShortsItems.reduce((sum, item) => sum + item.quantity, 0);

    return {
      items: LongShortsItems,
      count: LongShortsItemsCount
    };
  }

  const GetBrasItemsInCart = (cart) => {
    let BrasItems = cart.items.filter((item) => {
      return item.product_type == 'Bra' || item.product_type == 'Bras'
    });

    var totalbraIDs = [], propertiesBra = [];
    var BrasItemsCount = BrasItems.reduce((sum, item) => sum + item.quantity, 0);
    BrasItems.filter(function(item, index){
      totalbraIDs.push(item.id)
      propertiesBra.push(item.properties);
    })

    return {
      items: BrasItems,
      count: BrasItemsCount,
      Ids : totalbraIDs,
      line_properties : propertiesBra
    };
  }
  
  const GetSet_All_Site = async () =>{

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    // Get the set new updated Logic from Whole Site Start

      let cartItem = await UTILS.getCartJson();
  
      let BraItemsCount = GetBrasItemsInCart(cartItem).count || 0, AllUnderwearCount = AllUnderWearItemsInCart(cartItem).count || 0;
  
      let BrasArray=[],UnderwearsArray=[],BraProp=[],UnderwearProp=[], BraWthGtSt=[],UWearWithGtSt=[],AllPropGTST=[],noMatchedItem,timestamp = Date.now();
  
      if(BraItemsCount == 0 && AllUnderwearCount != 0){
        // if only underwear product present in cart, remove Get the Set properties.
        cartItem.items.forEach(function(item, index){
          var UnderWearIds = item.id.toString(), UnderWearGtBkNrml = item.properties, UnderWearGtBkNrmlQty = item.quantity;
          if(item.properties._getset_id != undefined){
            delete UnderWearGtBkNrml._getset_id;
            delete UnderWearGtBkNrml._get_set;
            let lineObjUnderWearOld = { id: UnderWearIds, quantity : UnderWearGtBkNrmlQty, properties: UnderWearGtBkNrml };
            return UTILS.updateCartItem(lineObjUnderWearOld).finally(() =>{ UTILS.refreshCart(); })
          }
        })
      }else if(BraItemsCount != 0 && AllUnderwearCount == 0){
        // if only bra product present in cart, remove Get the Set properties.
        cartItem.items.forEach(function(item, index){
          var BraIds = item.id.toString(), BraGtBkNrml = item.properties, BraGtBkNrmlQty = item.quantity;
          if(item.properties._getset_id != undefined){
            delete BraGtBkNrml._getset_id;
            let lineObjBraOld = { id: BraIds, quantity : BraGtBkNrmlQty, properties: BraGtBkNrml };
            return UTILS.updateCartItem(lineObjBraOld).finally(() =>{ document.dispatchEvent(new CustomEvent("cart:build")) })
          }
        })
      }else if(BraItemsCount > 0 && AllUnderwearCount > 0){
        // if both bra and underwear product present in cart, geting item details by product type.
        cartItem.items.forEach(function(item, index){
          if(item.product_type === 'Underwear' && !item.properties['_get_set']){
            UnderwearsArray.push(item);
            return false;
          }else if((item.product_type === 'Bra' || item.product_type === 'Bras') && (!item.properties['_getset_id'])){
            BrasArray.push(item);
            return false;
          }
        })
        
        // if both bra and underwear product present in cart, updating Get the Set properties.
        
        if(BrasArray[0] != undefined && UnderwearsArray[0] != undefined){
          if(BrasArray[0].properties['_getset_id'] == undefined && UnderwearsArray[0].properties['_getset_id'] == undefined && UnderwearsArray[0].properties['_get_set'] == undefined){
            BrasArray[0].properties['_getset_id'] = timestamp;
            let lineObjBra = { id: BrasArray[0].id.toString(), quantity : BrasArray[0].quantity, properties: BrasArray[0].properties }
            UTILS.updateCartItem(lineObjBra).then(() =>{
              UnderwearsArray[0].properties['_getset_id'] = timestamp; UnderwearsArray[0].properties['_get_set'] = 'true';
              let lineObjUnderwear = { id: UnderwearsArray[0].id.toString(), quantity : UnderwearsArray[0].quantity, properties: UnderwearsArray[0].properties };
              UTILS.updateCartItem(lineObjUnderwear).finally(() =>{ document.dispatchEvent(new CustomEvent("cart:build")) })
            })
            return false;
          }
        }

        // All properties storing in array.
        cartItem.items.forEach(function(item, index){ AllPropGTST.push(item.properties['_getset_id']) })
        // Checking duplicate get the set id's and storing in array.
        const check_duplicate_in_array=(input_array)=>{ const duplicates = input_array.filter((item, index) =>input_array.indexOf(item) !== index); return Array.from(new Set(duplicates)); }
        // Getting unmatched get the set id which is not get matched.
        AllPropGTST.forEach(function(item){ if(!check_duplicate_in_array(AllPropGTST).includes(item)){ noMatchedItem = item } })

        //Removing get the set id's from only Bra product if not matched.
        cartItem.items.forEach(function(item, index){ 
          if(noMatchedItem != undefined){
            if(item.properties['_getset_id'] === noMatchedItem){
              delete item.properties._getset_id
              let updateOldProp = {id:item.id.toString(), quantity: item.quantity, properties: item.properties};
              UTILS.updateCartItem(updateOldProp).finally(() =>{ document.dispatchEvent(new CustomEvent("cart:build")) })
              return false;
            }
          }
        })
      }

    // Get the set new updated Logic from Whole Site End
    
  }
  
  const FREE_GIFT_VARIANTS = [];

  var all_products = [];
  const TextReadMoreLess = () => {
    let ApplyReadMore = () => {
      document.querySelectorAll('[data-read_more_less="true"]').forEach(($section) => {
        let init_class = 'read-more-initialized';
        if ($section.classList.contains(init_class)) return;

        if ($section.querySelectorAll('p:not(:empty)').length > 1) {
          $section.insertAdjacentHTML('beforeend', '<a href="#" data-read-more-toggle>Read More</a>');
        }
  
        $section.querySelectorAll('[data-read-more-toggle]').forEach(($readMoreToggle) => {
          $readMoreToggle.addEventListener('click', (e) => {
            e.preventDefault();
            let toggle = JSON.parse($section.dataset.read_more_less);
            $section.dataset.read_more_less = !toggle;
            $readMoreToggle.innerText = !toggle ? 'Read More' : 'Read Less';
          });
        });
        $section.classList.add(init_class);
      });  
    }

    ApplyReadMore();

    ['shopify:block:deselect','shopify:section:unload'].forEach((e_type) => {
      document.addEventListener(e_type, (e) => {
        // console.log(e);
        setTimeout(ApplyReadMore, 100);
      });
    });
  }

  const ProductUpsells = async () => {
    let $container = document.querySelector('.product-block--upsells'); 
    if (!$container) return;
    let upsell_items = Array.from($container.querySelectorAll('[data-product]')).map(item => item.dataset.product);
    let upsells = await Promise.all(upsell_items.map((handle) => fetch(`/products/${ handle }.js`).then(res => res.json())));
    let color_option_id = 'option1';

    if (!upsells) return;

    let ToggleUpsells = () => {
      let count = $container.querySelectorAll('[data-matching_color="true"]').length;
      $container.classList.toggle('hide', count == 0);
    }
    // ToggleUpsells();

    // Add upsell to cart
    document.querySelectorAll('.product-block--upsells [data-product]').forEach(($upsell, index) => {
      $upsell.querySelector('.add-to-cart').addEventListener('click', (e) => {
        e.preventDefault();let lineItemObj;let itemsToAdd;
        // console.log(e.target.getAttribute('UnderwearWithUpsell'))
        document.querySelectorAll(`.CartItemsloop__Wp[upsell="false"]`).length;
        if ( document.querySelectorAll(`.CartItemsloop__Wp[upsell="false"]`).length > 0 && e.target.getAttribute('UnderwearWithUpsell') != null ){
        var trigger_key = document.querySelector(`.CartItemsloop__Wp[upsell="false"]`).getAttribute('data-key');
        let upsell = upsells[index];
        let selected_values = Array.from($upsell.querySelectorAll('input[type=radio]:checked')).map(item => item.value);
        let variant = upsell.variants.find(v => v.options.join('/') == selected_values.join('/'));          
        let variant_id = variant.id;
        let timestamp = Date.now();
        if(document.body.hasAttribute('CustomerExists')){
          properties['_CustomerExists'] = 'true';
          lineItemObj.properties['_CustomerExists'] = document.body.getAttribute('customerEmail');
        }
        let properties = {
          '_get_set': true,
          '_getset_id': timestamp,
          '_CountryEnabled':'USA'
        };
         if ( document.body.getAttribute('CountryEnabled') == null ){ 
           lineItemObj = {id: trigger_key};    
         }else{
           lineItemObj = {id: trigger_key,properties: {'_getset_id': timestamp,'_CountryEnabled':'USA'}};       
         }          
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(lineItemObj)
        })
       .then(() => {
         if ( document.body.getAttribute('CountryEnabled') == null ){ 
           itemsToAdd = [{id: variant_id,quantity: 1}];
         }else{
           itemsToAdd = [{id: variant_id,quantity: 1, properties: properties}];          
         }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: itemsToAdd })
          })
          .then((res) => res.json()).then((res) => {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true
            }));
             document.dispatchEvent(new CustomEvent('cart:updated'));  
          })
          .catch(console.error); 
         
         });
        }else{

            let upsell = upsells[index];
            let selected_values = Array.from($upsell.querySelectorAll('input[type=radio]:checked')).map(item => item.value);
            let variant = upsell.variants.find(v => v.options.join('/') == selected_values.join('/'));let variant_id = variant.id;
            let ProductMap;
            if(document.body.hasAttribute('CustomerExists')){
              ProductMap.properties['_CustomerExists'] = document.body.getAttribute('customerEmail');
            }
             if ( document.body.getAttribute('CountryEnabled') == null ){ 
               ProductMap = {id: variant_id,quantity: 1}
             }else{
               ProductMap = {id: variant_id,quantity: 1,properties:{'_CountryEnabled': 'USA'}}
             }
              UTILS.addItemsToCart([
                ProductMap
              ]);          
        }
        

      });
    });

  }

  const UpdateProductGrid = ($product, product, color) => {
    // console.log({ $product, color, product });
    if (product) {
      let color_option = product.color_option;

      let size_option = product.size_option;

      let color_variants = product.variants.filter(v => v[color_option.option_id] == color);
      let color_variant = color_variants.find(v => v.available) || color_variants[0];

      // update color name
      if (color_variant) {
        if($product.querySelector('.grid-product__options .selected-color')){
          $product.querySelector('.grid-product__options .selected-color').textContent = color_variant[color_option.option_id];
        }
      }
      // add variant coupon
      if (color_variant){
        // console.log('coupon:'+color_variant.coupon);
        $product.querySelector('.grid-product__options .variant_coupon').textContent = color_variant.coupon;
      }
      // update variant url
      if (color_variant) {
        if(document.body.classList.contains('vaultCollectionActive') && window.location.href.includes('filter.v.option.color') || window.location.href.includes('filter.v.m.custom.size_filter')){
        }else{
          $product.querySelectorAll('a').forEach(($link) => {
            let variant_url = `/products/${ product.handle }?variant=${ color_variant.id }`;
            $link.setAttribute('href', variant_url);
          });
        }
      }
      
      // update variant media
      if(document.body.classList.contains('vaultCollectionActive') && window.location.href.includes('filter.v.option.color') || window.location.href.includes('filter.v.m.custom.size_filter')){
      }else{
        let $featured_img = $product.querySelector('.featured-image:not(.img-override) img');
        if ($featured_img && color_variant && color_variant.media) {
          if( $featured_img.classList.contains('preloaded_image') ){
            let resizedV$img = color_variant.media.src.replace('.png','_413x.png');
            resizedV$img = color_variant.media.src.replace('.jpg','_413x.jpg');
            $featured_img.setAttribute('src', resizedV$img);
            $featured_img.setAttribute('srcset', resizedV$img);
          }else{
            $featured_img.setAttribute('data-src', color_variant.media.img_url);
            $featured_img.classList.add('lazyload');            
          }
  
          let $hover_img = $product.querySelector('.hover-image:not(.img-override) img');
          if($hover_img){
            if(color_variant.media.hover_img_url){
              $hover_img.setAttribute('data-src', color_variant.media.hover_img_url);
            }else{
              $hover_img.setAttribute('data-src', color_variant.media.img_url);
            }
            $hover_img.classList.add('lazyload');
          }
        }
      }

      // update size selection
      if (color_variants.length && size_option) {
        $product.querySelectorAll(`.variant-input-wrap[data-index="${ size_option.option_id }"] .variant-input`).forEach(($size) => {
          $size.querySelector('input').checked = false;
          let size = $size.dataset.value;
          let size_variant = color_variants.find(v => v[size_option.option_id] == size);
          if (size_variant) {
            let $size_label = $size.querySelector('label');
            $size_label.classList.toggle('disabled', !size_variant.available);
            $size_label.dataset.variant_id = size_variant.id;
            $size_label.dataset.discount = size_variant.discount;
            $size_label.dataset.price = size_variant.price;
          }else{
            let $size_label = $size.querySelector('label');
            // console.log($size)
            $size_label.classList.toggle('disabled', true);
          }
        });
      }

      if(color_variants.length && color_option){
        $product.querySelectorAll(`.variant-input-wrap[data-index="${ color_option.option_id }"] .variant-input`).forEach(($color) => {
          let color = $color.dataset.value;
          let color_variant = color_variants.find(v => v[color_option.option_id] == color);
          let $color_label = $color.querySelector('label');
          if(color_variant){
            $color_label.dataset.variant_id = color_variant.id;
            $color_label.dataset.discount = color_variant.discount;
            $color_label.dataset.price = color_variant.price;
          }
        })
      }

      // update price
      let $price = $product.querySelectorAll('.priceContainerMN'), hiddenSelectorVariant = $product.querySelector('[HiddenSelectorAll]'),
          selected_one_color= $product.querySelector('fieldset[name="Color"] input[type="radio"]:checked') 
                              ? $product.querySelector('fieldset[name="Color"] input[type="radio"]:checked').value
                              : $product.querySelector('fieldset[name="Color"] input[type="radio"][checked]') ? $product.querySelector('fieldset[name="Color"] input[type="radio"][checked]').value
                              : console.log('not found color selected'),
          selected_one_size= $product.querySelector('fieldset[name="Size"] input[type="radio"]:checked') 
                             ? $product.querySelector('fieldset[name="Size"] input[type="radio"]:checked').value
                             : $product.querySelector('fieldset[name="Size"] input[type="radio"][checked]') ? $product.querySelector('fieldset[name="Size"] input[type="radio"][checked]').value
                             : console.log('not found size selected');

      if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]')){
        let variant_discount = parseInt(100-hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.discount),
            variant_discount_off = parseInt(100*hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.staticOff),
            variant_price = parseInt(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.price),
            crntVrntPriceWithMoney = theme.Currency.formatMoney(variant_price, theme.settings.moneyFormat);


        // console.log('YESSSSSSSSSSSSSSSS');
        
        if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.discount > 0){
          let discountedPrice = variant_price * (variant_discount/100), DiscPriceWithMoney = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
          $price.forEach(function(price){
            if(price.classList.contains('discountedPrice')){
              price.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span style="color:red">${DiscPriceWithMoney}</span>`;
            }else{
              price.innerHTML = `${crntVrntPriceWithMoney}`;
            }
          })
        }else if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.staticOff > 0){
          // console.log('yes its');
          let discountedPriceOff = variant_price - variant_discount_off, DiscPriceWithMoneyOff = theme.Currency.formatMoney(discountedPriceOff, theme.settings.moneyFormat);
           $price.forEach(function(price){
            if(price.classList.contains('discountedPrice')){
              price.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span style="color:red">${DiscPriceWithMoneyOff}</span>`;
            }else{
              price.innerHTML = `${crntVrntPriceWithMoney}`;
            }
          })
        }else if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.discount == 0){
          $price.forEach(function(price){
            price.innerHTML = `${crntVrntPriceWithMoney}`;
          })
        }
      }
    }
  }

  const CollectionProductCards = () => {
    document.querySelectorAll('.grid-product:not(.grid-tile):not(.init)').forEach(($product) => {
      $product.classList.add('init','dsdsdsd');
      let $productJsonData = $product.querySelector('[data-product-json]');
      if (!$productJsonData) return;
      UTILS.convertStringToJS($productJsonData.innerHTML);
      all_products.push(product);

      let color_option = product.options_with_values.find(opt => ['Color'].indexOf(opt.name) !== -1);
      if(color_option){
        color_option.option_id = `option${ color_option.position }`;
        product.color_option = color_option;
      }

      let size_option = product.options_with_values.find(opt => ['Size'].indexOf(opt.name) !== -1);
      if(size_option){
        size_option.option_id = `option${ size_option.position }`;
        product.size_option = size_option;
      }

      // remove selected size on load
      if(color_option && size_option){
        $product.querySelectorAll(`.variant-input-wrap[data-index="${ size_option.option_id }"] .variant-input`).forEach(($size) => {
          if(!window.location.href.includes('filter') || !document.body.classList.contains('vaultCollectionActive')){
            $size.querySelector('input').checked = false;
          }
          
          let $color = $product.querySelector(`.variant-input-wrap[data-index="${ color_option.option_id }"] input:checked`) ||
                       $product.querySelectorAll(`.variant-input-wrap[data-index="${ color_option.option_id }"] input`)[0];

          let color;
          if($color){ color = $color.value; }
          let color_variants = product.variants.filter(v => v[color_option.option_id] == color);
  
          // update product grid on load
          UpdateProductGrid($product, product, color);
  
          // set size availability on load
          let size = $size.dataset.value;
          let size_variant = color_variants.find(v => v[size_option.option_id] == size);

          // Filters Page Script on change and load
          if(document.body.classList.contains('vaultCollectionActive')){
            var url = window.location.href, sizeFilterArray=[];
            if(size_variant){
              let $size_label = $size.querySelector('label');
              $size_label.classList.toggle('disabled', !size_variant.available);
              if($size_label.closest('.grid-product__content').querySelector('.AddToCartVault')){
                if($size_label.closest('.grid-product__content').querySelector('.AddToCartVault')){
                  $size_label.closest('.grid-product__content').querySelector('.AddToCartVault').setAttribute('disabled','disabled');
                }
              }
              if(!window.location.href.includes('filter.v.m.custom.size_filter')){
                if(!size_variant.available){
                  $size_label.parentNode.classList.add('hide');
                  if($size_label.closest('.grid-product__content').querySelector('.AddToCartVault')){
                    $size_label.closest('.grid-product__content').querySelector('.AddToCartVault').setAttribute('disabled','disabled');
                  }
                }
              }
              if(document.body.classList.contains('vaultCollectionActive') && !window.location.href.includes('filter.v.option.color')){
                $size_label.dataset.variant_id = size_variant.id;
              }
            }else if(!size_variant){
              if(!window.location.href.includes('filter.v.m.custom.size_filter')){
                let $size_label = $size.querySelector('label');
                // $size_label.parentNode.classList.add('hide');
                $size_label.classList.toggle('disabled', false);
                if($size_label.closest('.grid-product__content').querySelector('.AddToCartVault')){
                  $size_label.closest('.grid-product__content').querySelector('.AddToCartVault').setAttribute('disabled','disabled');
                }
              }
            }

            // When filter selected on change or load
            if(url.includes('filter')){
              // console.log('filter ar eapplie');
              // Adding class on body when any filter selected
              document.body.classList.add('FilteringDesignActive');
              
              // Adding and removing class on body when size filter toggled
              if(url.includes('filter.v.m.custom.size_filter')){ document.body.classList.add('SizeFiltersActive'); }
              else if(!url.includes('filter.v.m.custom.size_filter')){document.body.classList.remove('SizeFiltersActive');}

              // Adding and removing class on body when color filter toggled
              if(url.includes('filter.v.option.color')){ document.body.classList.add('ColorFiltersActive'); }
              else if(!url.includes('filter.v.option.color')){ document.body.classList.remove('ColorFiltersActive'); }

              // Adding and removing class on body when discount filter toggled
              if(url.includes('filter.v.m.custom.variant_discount')){ document.body.classList.add('DiscountFiltersActive'); }
              else if(!url.includes('filter.v.m.custom.variant_discount')){ document.body.classList.remove('DiscountFiltersActive'); }               

              if(url.includes('&')){ var spliterLink = url.split('?')[1].split('&'); }
              else{ var spliterLink = [url.split('?')[1]] }
              spliterLink.forEach(function(link){
                if(link.split('=')[0] == 'filter.v.m.custom.size_filter'){ sizeFilterArray.push(link) } 
              })

              // Logic for soldout and available sizes when we use size filter
              // console.log(sizeFilterArray.length);
              if(sizeFilterArray.length == 1){
                if(sizeFilterArray[0].split('=')[1].includes('Bra')){ var sizeSelected = sizeFilterArray[0].split('=')[1].split('_')[1] }
                else if(sizeFilterArray[0].split('=')[1].includes('Und')){ var sizeSelected = 'Fits '+sizeFilterArray[0].split('=')[1].split('_')[1] }

                document.querySelectorAll('#CollectionAjaxContent .size-swatches [data-value]').forEach(function(size){ size.classList.add('hide'); })
                // console.log(sizeSelected);
                document.querySelectorAll('#CollectionAjaxContent [data-value="'+sizeSelected+'"]').forEach(function(size){ size.classList.remove('hide'); })
                document.querySelectorAll('#CollectionAjaxContent .size-swatches .variant-input-wrap').forEach((elm)=>{
                  if(elm.querySelectorAll('[data-value="'+sizeSelected+'"]').length == 0){
                    if(elm.closest('.grid-product__content').querySelector('.buttonWrprVault') && elm.closest('.grid-product__content').querySelector('.buttonWrprVault').querySelector('.ButtoncartYouMayLike ')){
                      elm.closest('.grid-product__content').querySelector('.buttonWrprVault').querySelector('.ButtoncartYouMayLike ').innerHTML = 'Sold Out';
                    }
                    elm.closest('.IndexGridLayoutWp').classList.add('hide');
                  }
                });
                document.querySelectorAll('#CollectionAjaxContent [data-value="'+sizeSelected+'"]').forEach(function(size){
                  if(!size.classList.contains('hide')){ size.querySelector('label').classList.remove('disabled'); }
                })

                // If all the colors are soldout then logic to hide the product card
                setTimeout(function(){
                  var color_counter_prds = $product.querySelectorAll('fieldset[name="Color"] .variant-input').length - $product.querySelectorAll('fieldset[name="Color"] .variant-input.hide').length;
                  $product.setAttribute('counter',color_counter_prds)
                  if(color_counter_prds == 0){
                    $product.classList.add('hide')
                  }
                }, 100)
              }
              if(sizeFilterArray.length > 1){
                document.querySelectorAll('#CollectionAjaxContent .size-swatches .variant-input').forEach(function(size){
                  // if(!size.classList.contains('hide')){
                  //   size.querySelector('label').classList.add('disabled');
                  // }
                  size.classList.add('hide')
                })
                sizeFilterArray.forEach(function(size){
                  if(size.split('=')[1].includes('Bra')){ var sizeMultiSelected = size.split('=')[1].split('_')[1] }
                  else if(size.split('=')[1].includes('Und')){ var sizeMultiSelected = 'Fits '+size.split('=')[1].split('_')[1] }
                  document.querySelectorAll('#CollectionAjaxContent .size-swatches .variant-input[data-value="'+sizeMultiSelected+'"]').forEach(function(size){
                    size.classList.remove('hide')
                  })
                })
              }
              if(window.innerWidth < 769){
                if(window.location.href.includes('filter.v.option.color') && !window.location.href.includes('filter.p.m.custom.category_filter') && !window.location.href.includes('filter.p.m.custom.features_filter') && !window.location.href.includes('filter.p.m.custom.neckline_filter') && !window.location.href.includes('filter.v.m.custom.size_filter')){
                  document.querySelectorAll('#CollectionAjaxContent .size-swatches .variant-input label').forEach((elm)=>{
                    elm.closest('.variant-input').classList.remove('hide');
                    elm.classList.remove('disabled')
                  });
                }
              }
            }else if(!url.includes('filter')){

              // Product counts updation when filter removed
              document.body.classList.remove('FilteringDesignActive');
              $('.CountPDInit').addClass('hide');
              $('.ViewResultsCount').html('View Results');
              document.querySelectorAll('[section="collection-blocks"] .IndexGridLayoutWp').forEach((product)=>{
                product.querySelectorAll('.size-swatches .variant-input label').forEach(function(label){
                  if(label.classList.contains('disabled')){
                    label.parentNode.classList.add('hide');
                  }
                })
              });
            }
            
          }else{
            if(size_variant){
              let $size_label = $size.querySelector('label');
              $size_label.classList.toggle('disabled', !size_variant.available);
              $size_label.dataset.variant_id = size_variant.id;
            }
          }
        });

        // Updation of button according to availability Soldout or Select size.
        if(document.body.classList.contains('vaultCollectionActive')){
          var counter_prds = $product.querySelectorAll('.size-swatches .variant-input').length - $product.querySelectorAll('.size-swatches .variant-input.hide').length;
          if(counter_prds > 0){
            if($product.querySelector('.AddToCartVault')){
              $product.querySelector('.AddToCartVault').innerHTML = 'Select Size';
            }
          }else{
            if($product.querySelector('.AddToCartVault')){
              $product.querySelector('.AddToCartVault').innerHTML = 'Sold out';
            }
          }
        }
      }

      // color change functionality
      $product.addEventListener('click', (e) => {
        let $target = e.target;
        let $product = $target.closest('.grid-product');
        // remove override classes to resume images switching
        $product.querySelectorAll('.img-override').forEach(($item) => {
          $item.classList.remove('img-override');
        });
        let product_id = $product.dataset.id;
        let product = all_products.find(p => p.id == product_id);
        if (product) {
          let isColorSwatch = $target.closest('.color-swatch') !== undefined;
          if (isColorSwatch) {
            let color = $target.value;
            UpdateProductGrid($product, product, color);
          }  
        }
      });

      // product-grid event handlers
      $product.addEventListener('click', (e) => {

        // When filter is not selected
        if(!window.location.href.includes('filter')){
          let $target = e.target;
          if($target.localName == 'label'){
            // size selection - ajax add to cart
            let isSizeSwatch = $target.dataset.variant_id;
            if(isSizeSwatch){
              $target.parentNode.querySelector('input').checked = true;
              let isSoldout = $target.classList.contains('disabled');
              if(isSoldout){
                if (document.body.classList.contains('NewCustom-product')){
                  $target.closest('.CV-gridContent').querySelector('.ButtoncartYouMayLike').innerHTML = '<span>Sold Out</span>';
                  $target.closest('.CV-gridContent').querySelector('.ButtoncartYouMayLike').classList.add('disabled');
                  return false;
                }else if(document.body.classList.contains('vaultCollectionActive') && !window.location.href.includes('filter')){
                  if($target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike')){
                    $target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike').setAttribute('disabled','disabled');
                    $target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike').innerHTML = 'Sold out';
                  }
                  return false;
                }else{
                  return
                }
              }
    
              let variant_id = $target.dataset.variant_id;
              
              if(document.body.classList.contains('NewCustom-product')){
                $target.closest('.CV-gridContent').querySelector('.ButtoncartYouMayLike').innerHTML = '<span>Add to cart</span>';
                $target.closest('.CV-gridContent').querySelector('.ButtoncartYouMayLike').classList.remove('disabled');
                $target.closest('.CV-gridContent').querySelector('.ButtoncartYouMayLike').setAttribute('varaint_id',variant_id);
              }else if(document.body.classList.contains('vaultCollectionActive')){
                let product_id = $product.dataset.id;
                let product = all_products.find(p => p.id == product_id);
                if (product) {
                  let isColorSwatch = $target.closest('.color-swatch') !== undefined;
                  if (isColorSwatch) {
                    let color = $target.closest('.variant-input').querySelector('input').value;
                    UpdateProductGrid($product, product, color);
                  }  
                }
                
                if($target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike')){
                  $target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike').setAttribute('varaint_id',variant_id)
                  $target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike').removeAttribute('disabled');
                  $target.closest('.grid-product__content').querySelector('.buttonWrprVault .ButtoncartYouMayLike').innerHTML = 'Add to cart';
                }
              }
              else{
                let ProductMap;
                let product_id = $product.dataset.id;
                let product = all_products.find(p => p.id == product_id);
                if (product) {
                  let isColorSwatch = $target.closest('.color-swatch') !== undefined;
                  if (isColorSwatch) {
                    let color = $target.closest('.variant-input').querySelector('input').value;
                    UpdateProductGrid($product, product, color);
                  }  
                }
                if(document.body.hasAttribute('CustomerExists')){ if(ProductMap){ ProductMap.properties['_CustomerExists'] = document.body.getAttribute('customerEmail'); } }
                if(document.body.getAttribute('CountryEnabled') == null){
                  ProductMap = {id: variant_id,quantity: 1}
                }else{
                  ProductMap = {id: variant_id,quantity: 1,properties:{'_CountryEnabled': 'USA'}}
                }
                
                if( $target.closest('.grid-product__form').querySelector('.ProductVwDetailsIndes').querySelectorAll('a').length == 0 ){
                  UTILS.addItemsToCart([ ProductMap ]);
                }
                
              }
      
            }
    
            // Mobile toggle sizes
            let $mobileToggle = $target.closest('.MobileSizeSelector_Toggle');
            let isMobileToggle = $mobileToggle !== null;
            if (isMobileToggle) {
              $mobileToggle.classList.toggle('open');
            }
          }
        }else{
          
          // After selection of filter

          // Size change logic
          if(e.target.closest('fieldset[name="Size"]') && e.target.localName == 'label'){
            e.target.parentNode.querySelector('input').checked = true
            var sizeSelected = e.target.innerHTML.trim();
            var colorSelected = e.target.closest('.grid-product__content').querySelector('.selected-colors').innerHTML.trim();
            var concatedSize = colorSelected+' / '+sizeSelected;
            if(e.target.closest('.grid-product__content').querySelector('[hiddenselectorall] option[data-title="'+concatedSize+'"]')){
              var option_value = e.target.closest('.grid-product__content').querySelector('[hiddenselectorall] option[data-title="'+concatedSize+'"]').value,
                  option_url = e.target.closest('.grid-product__content').querySelector('[hiddenselectorall] option[data-title="'+concatedSize+'"]').dataset.url;
              if(e.target.closest('.grid-product__content').querySelector('[hiddenselectorall] option[data-title="'+concatedSize+'"]').dataset.available == 'true'){
                e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').setAttribute('varaint_id',option_value);
                e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').removeAttribute('disabled');
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault a').setAttribute('href',option_url);
                e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').innerHTML = 'Add to Cart';
              }else if(e.target.closest('.grid-product__content').querySelector('[hiddenselectorall] option[data-title="'+concatedSize+'"]').dataset.available == 'false'){
                e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').setAttribute('varaint_id',option_value)
                e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').setAttribute('disabled','disabled');
                e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').innerHTML = 'Sold out';
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault a').setAttribute('href',option_url);
              }
            }else if(!e.target.closest('.grid-product__content').querySelector('[hiddenselectorall] option[data-title="'+concatedSize+'"]')){
              e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').setAttribute('disabled','disabled');
              e.target.closest('.grid-product__content').querySelector('.ButtoncartYouMayLike').innerHTML = 'Unavailable';
            }
          }else if(e.target.closest('fieldset[name="Color"]') && e.target.localName == 'label'){

            // Color Change Logic
            if(e.target.closest('.grid-product__content').querySelector('.AddToCartVault')){
              e.target.closest('.grid-product__content').querySelector('.AddToCartVault').innerHTML = 'Select Size';
              e.target.closest('.grid-product__content').querySelector('.AddToCartVault').setAttribute('disabled','disabled');
            }
            var selected_color_one = e.target.closest('.variant-input').querySelector('input').value;
            e.target.closest('.grid-product__content').querySelectorAll('[hiddenselectorall] option[data-color="'+selected_color_one+'"]').forEach(function(Color,index){
              if(index == 0){
                var url_variant = Color.dataset.url, image_variant = Color.dataset.img, hoverImg_variant = Color.dataset.hoverimg;
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault a').setAttribute('href',url_variant);
                e.target.closest('.grid-product__content').querySelector('.ProductVwDetailsIndes a').setAttribute('href',url_variant);
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault .selected-colors').innerHTML = selected_color_one;
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault .featured-image img').setAttribute('src',image_variant);
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault .featured-image img').setAttribute('srcset',image_variant);
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault .hover-image img').setAttribute('src',hoverImg_variant);
                e.target.closest('.grid-product__content').querySelector('.AboveContentVault .hover-image img').setAttribute('srcset',hoverImg_variant);
              }
            })
          }          
        }
      });
    });

    // Update Filters Count when filter is selected.
    if(window.location.href.includes('filter')){
      setTimeout(function(){
        var cardProductsCount = document.querySelectorAll('#CollectionAjaxContent .grid-product').length - document.querySelectorAll('#CollectionAjaxContent .grid-product.hide').length;
        if(cardProductsCount > 0){
          $('.CountPDInit').html('('+cardProductsCount+' items)');
          $('.CountPDInit').removeClass('hide');
          $('.ViewResultsCount').html('View Results '+'('+cardProductsCount+')');
          $('.collection-filter__group .tag.tag--active .tag-results').html('('+cardProductsCount+')')
        }else{
          if(!document.querySelector('.NoResultsFilter')){ document.querySelector('#CollectionAjaxContent [data-collection-container]').innerHTML += '<div class="NoResultsFilter">No Results Found</div>'; }
          else{ document.querySelector('.NoResultsFilter').innerHTML = 'No Results Found'; }
          $('.CountPDInit').addClass('hide');
          $('.ViewResultsCount').html('View Results');
        }
      }, 150)
    }

    var YoumayLikeButton = document.querySelectorAll('.ButtoncartYouMayLike');
    if(YoumayLikeButton.length > 0){
      YoumayLikeButton.forEach(function(button){
        button.addEventListener('click',function(e){
          e.preventDefault();
          // console.log('Working')
          var recommend_ID = this.getAttribute('varaint_id');
          let ProductMap;
          if ( document.body.getAttribute('CountryEnabled') == null ){ 
            ProductMap = {id: recommend_ID,quantity: 1}
          }else{
            ProductMap = {id: recommend_ID,quantity: 1,properties:{'_CountryEnabled': 'USA'}}
          }
          if(document.body.hasAttribute('CustomerExists')){
            ProductMap.properties['_CustomerExists'] = document.body.getAttribute('customerEmail');
          }
          UTILS.addItemsToCart([
            ProductMap
          ]);
        })
      })
    }
  }

  const Accordions = () => {
    document.querySelectorAll('.accordion-trigger a').forEach(($item) => {
      $item.addEventListener('click', (e) => {
        e.preventDefault();
        let $trigger = e.target.closest('.accordion-trigger');
        var contentID = e.target.closest('a').getAttribute('data-accordion');
        let $accordion = document.getElementById(`accordion-${ contentID }`);
        if (!$accordion) return;
        
        if ($accordion.classList.contains('is-expanded')){
          $accordion.classList.remove('is-expanded');
          $trigger.setAttribute('aria-expanded','false');
        }
        else{
          $accordion.classList.add('is-expanded');
          $trigger.setAttribute('aria-expanded','true');
        }  
      });
    });
  }

  const InitCartGetSetUpsells = async () => {
    let cart = await UTILS.getCartJson();
    let getset_itemsToRemove = {};
    cart.items.forEach((item) => {
      let isGetSetItem = item.properties['_get_set'];
      if (isGetSetItem) {
        let mainItem = cart.items.find(it => it.id !== item.id && it.properties['_getset_id'] == item.properties['_getset_id']);
        if (!mainItem) {
          var getBacktoNrml = item.properties ;
          if(item.properties['_get_set'] != undefined){ delete getBacktoNrml._get_set; } 
          if(item.properties['_getset_id'] != undefined){ delete getBacktoNrml._getset_id; }
          let UnderwearGtBkNrml = { id: item.id.toString(), quantity : item.quantity, properties: getBacktoNrml };
          UTILS.updateCartItem(UnderwearGtBkNrml).finally(() =>{ UTILS.refreshCart(); })
        }
      }
    });

    // check cart and calculate if get set to be triggered
    cart.items.forEach((item, itemIndex0) => {
      let show_getset = false;
      // if item doesn't have prop _getset_id yet, show get set upsell
      let isGetSetItem = item.properties['_get_set'];
      let getset_id = item.properties['_getset_id'];
      if (!isGetSetItem && !getset_id) {
        show_getset = true;
      }
      if (!isGetSetItem && getset_id) {
        let added = cart.items.filter(i => i.properties['_getset_id'] == getset_id).length == 2;
        show_getset = !added;
      }
      document.querySelectorAll(`.cart__item[data-line_index0="${ itemIndex0 }"]`).forEach(($cartItem) => {
        let $cartUpsellItem = $cartItem.querySelector('.cart__item--upsell');
        if ($cartUpsellItem) {
          $cartUpsellItem.classList.toggle('hide', !show_getset);
        }
      });
    });

    document.querySelectorAll('.cart__item--upsell:not(.init)').forEach(($upsell) => {
      $upsell.classList.add('init');

      // Click events
      $upsell.addEventListener('click', (e) => {
        e.preventDefault();
        let $target = e.target;
        let trigger_key = $upsell.dataset.trigger_key;

        // Toggle upsell
        let isBtnToggle = $target.classList.contains('toggle-upsell') || $target.closest('.toggle-upsell');
        if (isBtnToggle) {
          let $itemUpsell = $upsell.querySelector('.item-upsell');
          $itemUpsell.classList.toggle('hide');
        }

        // Add to cart
        let isBtnAtc = $target.classList.contains('btn--atc-upsell');
        if (isBtnAtc) {
          let $size = $upsell.querySelector('select.size');
          let variant_id = $size.querySelector('option:checked').dataset.variantId;
          let timestamp = Date.now();
          let properties = {
            '_get_set': true,
            '_getset_id': timestamp
          };

          if ($target.dataset.preorder) {
            properties['_preorder_active'] = 'true';
            let preorder_date = $target.dataset.preorder_date;
            if (preorder_date) {
              properties['_preorder_date'] = preorder_date;
            }
          }

          // set main item prop for association
          UTILS.updateCartItem({
            id: trigger_key,
            properties: {
              '_getset_id': timestamp
            }
          })
          .then(() => {
            // add upsell to cart
            UTILS.addItemsToCart([
              {
                id: variant_id,
                quantity: 1,
                properties: properties
              }
            ]);
          });

        }
      });

      // Size selection
      $upsell.addEventListener('change', (e) => {
        let $target = e.target;
        let isSizeSelect = $target.classList.contains('size');
        if (isSizeSelect) {
          let $price = $upsell.querySelector('.CartItem__Price');
          if ($price) {
            $price.textContent = $target.querySelector('option:checked').dataset.price;
          }

          let $compare_price = $upsell.querySelector('.product__price--compare');
          if ($compare_price) {
            $compare_price.textContent = $target.querySelector('option:checked').dataset.compare_price;
          }

          let $btnAtc = $upsell.querySelector('.btn--atc-upsell');
          if ($btnAtc) {
            $btnAtc.disabled = false;

            let btnLabel = $btnAtc.dataset.preorder ? $btnAtc.dataset.preorder_label : $btnAtc.dataset.atc_label;
            $btnAtc.textContent = btnLabel;
            $btnAtc.classList.remove('btn--secondary');
            $btnAtc.classList.add('btn--primary');  
          }
        }
      });
    });

    // remove item from cart
    document.querySelectorAll('.cart__item-remove:not(.init)').forEach(($remove) => {
      $remove.addEventListener('click', (e) => {
        e.preventDefault();
        let key = e.currentTarget.dataset.key;
        let removeItem = {};
        removeItem[key] = 0;
        UTILS.removeItemsFromCart(removeItem);
      });
      $remove.classList.add('init');
    });
  }

  if(document.body.classList.contains('template-product')){
    let SeeInYourSize = (PRESET_SIZE) => { 
      let selector_modal = '[data-tool-tip="see-chart"]:not(.tool-tip-trigger)';
      let $modal = document.querySelector(selector_modal);
      let $modal_swiper = $modal.querySelector('.models-swiper');
      let num_slides = $modal_swiper.querySelectorAll('.swiper-slide').length;
      if (num_slides <= 4) {
        $modal_swiper.classList.add('models-swiper-centered');
      }
  
      let SelectModalSize = (size) => {
        let $sizeInput = $modal.querySelector(`.variant-input input[data-value="${ size }"]`)
          || $modal.querySelector(`.variant-input input[value="${ size }"]`);
  
        $modal.querySelectorAll('.variant-input input[type="radio"]').forEach(($input) => {
          $input.checked = false;
        });
        $sizeInput.checked = true;
        $sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
  
      let $initialSlide = $modal_swiper.querySelector(`.swiper-slide[data-size-value="${ PRESET_SIZE }"]`);
      let initialSlide = $initialSlide ? $initialSlide.dataset.index : 0;
  
      const models_swiper = new Swiper($modal_swiper, {
        initialSlide: initialSlide,
        slidesPerView: 4.5,
        spaceBetween: 10,
        centeredSlides: true,
        centeredSlidesBounds:true,
        loop: true, 
        simulateTouch: true,
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 4.5,
          }
        },
        on: {
          slideChange() {
            let $activeSlide = this.slides[this.activeIndex];
            let size = $activeSlide.dataset.size;
            SelectModalSize(size);  
          }
        }
      });
  
      // If PRESET SIZE
      setTimeout(() => {
        SelectModalSize(PRESET_SIZE);
      }, 0);
  
      $modal.addEventListener('click', (e) => {
        let $target = e.target;
      
        // modal size swatch click
        if ($target.closest('.variant-input') || $target.classList.contains('variant-input')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
  
          let $swatch = $target.closest('.variant-input') || $target;
          let size = $swatch.querySelector('input').dataset.value;
          SelectModalSize(size);
    
          $modal.querySelector('.selected-size').classList.remove('selected-size');
          let $slide = $modal.querySelector(`.swiper-slide:not(.swiper-slide-duplicate)[data-size="${ size }"]`);
          $slide.classList.add('selected-size');
        }
  
        // on image click, change size
        if ($target.closest('.swiper-slide') || $target.classList.contains('.swiper-slide')) {
          e.preventDefault();
          let $slide = $target.closest('.swiper-slide') || $target;
          let size = $slide.dataset.size;
          SelectModalSize(size);
        }
      });
  
      // on size change
      $modal.addEventListener('change', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let $modal_swiper = $modal.querySelector('.models-swiper');
        let models_swiper = $modal_swiper.swiper;
  
        let size = $modal.querySelector('input:checked').dataset.value;
        let $slides = $modal.querySelectorAll(`.models-swiper .swiper-slide[data-size="${size}"]`);
        if ($slides.length) { 
          let $slide = Array.from($slides).filter(($item) => !$item.classList.contains('swiper-slide-duplicate'))[0];
          if ($slide) {
            let slideIndex = parseInt($slide.dataset.index);
            models_swiper.slideToLoop(slideIndex, false);
          }
        }
      });
      
      // on main variant change
      document.addEventListener('variant:change', function(event) {
        var variant = event.detail.variant;
        let sizeraw = variant.option2;
        let size = sizeraw.toLowerCase().replace(/ /g,'-');
        SelectModalSize(size);
      });
    }
  
    document.addEventListener('tooltip:open', function(e) {
  
    new Swiper(".swiper.models-swiper", {
            slidesPerView: 4.5,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds:true,
            loop: true, 
            simulateTouch: true,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            breakpoints: {
              // when window width is >= 320px
              320: {
                slidesPerView: 2.5,
              },
              1024: {
                slidesPerView: 4.5,
              }
            }
          });
      let PRESET_SIZE = document.querySelector('.block-variant_picker input[data-index="option2"]:checked').value;
      if(e.detail.context == 'see-chart'){
        SeeInYourSize(PRESET_SIZE);
      }
      //console.log(e.detail.context)
    });
  }else{

    document.addEventListener('tooltip:open', function(e) {
      var page_modal_swiper = new Swiper(".swiper.models-swiper", {
        slidesPerView: 4.5,
        spaceBetween: 10,
        centeredSlides: true,
        centeredSlidesBounds:true,
        loop: true, 
        simulateTouch: true,
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 4.5,
          }
        }
      });
      let PRESET_SIZE = document.querySelectorAll('.tool-tip__inner .variant-input');
      PRESET_SIZE.forEach(function(evt){
        evt.addEventListener('click',function(e){
          e.preventDefault();
          PRESET_SIZE.forEach(function(evt){
            evt.querySelector('input').checked = false;
          })
          this.querySelector('input').checked = true;
          var CurrentVrnt = this.querySelector('input').value;
          let $slide = this.closest('.product-sizes').parentNode.querySelector('.models-swiper-container').querySelector(`.swiper-slide:not(.swiper-slide-duplicate)[data-size-value="${ CurrentVrnt }"]`);
          let SlideIndex = parseInt($slide.getAttribute('data-index'));
          let models_swiperGet = this.closest('.product-sizes').parentNode.querySelector('.models-swiper-container').querySelector('.swiper.models-swiper');
          let models_swiperGets = models_swiperGet.swiper;
          models_swiperGets.slideToLoop(SlideIndex, false,false);
        })
      })
    })
    
  }  

  const GetSpecificUnderWearItemsInCart =(cart) => {
    let PRODUCT_IDS = [

    ];

    let VARIANT_IDS = [
      40232743043181,
      40232743075949,
      40054589522029,
      40054589554797,
      40327932969069,
      40327932936301,
      40281150095469,
      40281150128237,
      39463986856045,
      54878922311,
      14054495617133,
      54878922375,
      14054500499565,
      54878922439,
      14054502400109,
      54878922567,
      14054505611373,
      29759610028141,
      29759633227885,
      54882989895,
      54882990087,
      54882990279,
      54882990471,
      54882990663,
      54882990727,
      31057807245421,
      31057848893549,
      31057897259117,
      31058726289517,
      31058739789933,
      31058765316205,
      39367541391469,
      39367540506733,
      39463985086573,
      39664822911085,
      39664822943853,
      40232743043181, 
      40232743075949, 
      40054589522029, 
      40054589554797, 
      40327932969069, 
      40327932936301, 
      40281150095469, 
      40281150128237,
      39896613683309,
      39896613716077,
      39896613748845,
      39896613781613,
      39896613814381,
      39896613847149,
      40327906295917,
      40327906328685,
      40327906361453,
      40327906394221,
      40327906426989,
      40327906459757,
      32133506891885,32133506957421,32133507022957,32133507088493,32133507154029,32133507219565,40327799767149,40327799636077,40327799668845,40327799701613,40327799734381,40327799767149,39896613683309,39896613716077,39896613748845,39896613781613,39896613814381,39896613847149,40327906295917,40327906328685,40327906361453,40327906394221,40327906426989,40327906459757,33024072351853,33024083656813,33024084148333,33024084738157,33024085426285,33024086114413,40327886962797,40327886995565,40327887028333,40327887061101,40327887093869,40327887126637
    ];

    let items = cart.items.filter((item) => {
      let isProductInCart = PRODUCT_IDS.indexOf(item.product_id) !== -1;
      let isVariantInCart = VARIANT_IDS.indexOf(item.variant_id) !== -1;
      return isProductInCart || isVariantInCart;
    })
    
    var itemsCount = items.reduce((sum, item) => sum + item.quantity, 0);
      
    return {
      items: items,
      count: itemsCount
    };
  }

  const UpdateCartMessaging = async () => {
    let cart = await UTILS.getCartJson();

    let underWearItemsCount = GetUnderWearItemsInCart(cart).count || 0;
    let longShortItemsCount = GetLongShortItemsInCart(cart).count || 0;
    let BraItemsCount = GetBrasItemsInCart(cart).count || 0;
    
    let message;let girlShrtMsg;let BrasMsg;
    
    function newMessageFirst(count, price) {
      let price_format = UTILS.formatMoney(price * 100);
      let remaining = count-underWearItemsCount;
      let cart_section_settings = JSON.parse(document.querySelector('#CartDrawer').dataset.sectionSettings);
      let message = cart_section_settings.cart_dynamic_message 
        || `Want ${count} pairs for $${price}? Add ${remaining} more: Bikini or Thong`;
      message = message.replace(/{count}/g, count).replace(/{price}/g, price_format).replace(/{remaining}/g, remaining);
      //console.log(message);
      return message;
    }

    function newMessageSecond(count, price) {
      let price_format = UTILS.formatMoney(price * 100);
      let remaining = count-longShortItemsCount;
      let girlShrtMsg = `Want ${count} pairs of Slip Short for $${price}? Add ${remaining} more pair${remaining > 1 ? 's' : ''}`;
      girlShrtMsg = girlShrtMsg.replace(/{count}/g, count).replace(/{price}/g, price_format).replace(/{remaining}/g, remaining);
      return girlShrtMsg;
    }

    function BrasMessageThird(price, discountedPrice) {
      let price_format = UTILS.formatMoney(price * 100);
      let BrasMsg = `Want $${price} off? Add another bra to your cart for $${discountedPrice} each`;
      return BrasMsg;
    }    

    if(longShortItemsCount < 3){
      girlShrtMsg = newMessageSecond(3, 60);
    }else if(longShortItemsCount >= 3 && longShortItemsCount < 6){
      girlShrtMsg = newMessageSecond(6, 120);
    }else if(longShortItemsCount >= 6 && longShortItemsCount < 9){
      girlShrtMsg = newMessageSecond(9, 180);
    }else if(longShortItemsCount >= 9 && longShortItemsCount < 12){
      girlShrtMsg = newMessageSecond(12, 240);
    }else if(longShortItemsCount >= 12 && longShortItemsCount < 15){
      girlShrtMsg = newMessageSecond(15, 300);
    }else if(longShortItemsCount >= 15 && longShortItemsCount < 18){
      girlShrtMsg = newMessageSecond(18, 360);
    }else if(longShortItemsCount >= 18 && longShortItemsCount < 21){
      girlShrtMsg = newMessageSecond(21, 420);
    }else if(longShortItemsCount >= 21 && longShortItemsCount < 24){
      girlShrtMsg = newMessageSecond(24, 480);
    }else if(longShortItemsCount >= 24 && longShortItemsCount < 27){
      girlShrtMsg = newMessageSecond(27, 540);
    }else if(longShortItemsCount >= 27 && longShortItemsCount < 30){
      girlShrtMsg = newMessageSecond(30, 600);
    }else if(longShortItemsCount >= 30 && longShortItemsCount < 33){
      girlShrtMsg = newMessageSecond(33, 660);
    }else if(longShortItemsCount >= 33 && longShortItemsCount < 36){
      girlShrtMsg = newMessageSecond(36, 720);
    }else if(longShortItemsCount >= 36 && longShortItemsCount < 39){
      girlShrtMsg = newMessageSecond(39, 780);
    }
    
    if (underWearItemsCount < 5) {
      message = newMessageFirst(5, 80);
    }else if (underWearItemsCount >= 5 && underWearItemsCount < 10) {
      message = newMessageFirst(10, 160);
    }else if (underWearItemsCount >= 10 && underWearItemsCount < 15) {
      message = newMessageFirst(15, 240);
    }else if (underWearItemsCount >= 15 && underWearItemsCount < 20) {
      message = newMessageFirst(20, 320);
    }else if (underWearItemsCount >= 20 && underWearItemsCount < 25) {
      message = newMessageFirst(25, 400);
    }else if (underWearItemsCount >= 25 && underWearItemsCount < 30) {
      message = newMessageFirst(30, 480);
    }else if (underWearItemsCount >= 30 && underWearItemsCount < 35) {
      message = newMessageFirst(35, 560);
    }else if (underWearItemsCount >= 35 && underWearItemsCount < 40) {
      message = newMessageFirst(40, 640);
    }else if (underWearItemsCount >= 40 && underWearItemsCount < 45) {
      message = newMessageFirst(45, 720);
    }else if (underWearItemsCount >= 45 && underWearItemsCount < 50) {
      message = newMessageFirst(50, 800);
    }else if (underWearItemsCount >= 50 && underWearItemsCount < 55) {
      message = newMessageFirst(55, 580);
    }else if (underWearItemsCount >= 55 && underWearItemsCount < 60) {
      message = newMessageFirst(60, 960);
    }

    if(BraItemsCount == 1){
      let offNow = (BraItemsCount+1)*10, discountedPrice = 88;
      BrasMsg = BrasMessageThird(offNow,discountedPrice);
    }else if(BraItemsCount == 2){
      let offNow = (BraItemsCount+1)*18, discountedPrice = 80;
      BrasMsg = BrasMessageThird(offNow, discountedPrice);
    }else if(BraItemsCount >= 3){
      let offNow = (BraItemsCount+1)*23, discountedPrice = 75;
      BrasMsg = BrasMessageThird(offNow, discountedPrice);
    }
    
    if (message !== undefined && message !== '') {
      if(document.querySelectorAll('.BikniThong__MessagesOffer').length > 0){
        document.querySelectorAll('.BikniThong__MessagesOffer').forEach( (target) =>{
          target.firstChild.innerHTML = `${message}`;target.style.display = "block";
        })
      }
    }
    
    if(girlShrtMsg !== undefined){
      if(document.querySelectorAll('.GirlShot__MessagesOffer').length > 0){
        document.querySelectorAll('.GirlShot__MessagesOffer').forEach( (target) =>{
          target.firstChild.innerHTML = `${girlShrtMsg}`;target.style.display = "block";
        })
      }
    }

    if(BrasMsg !== undefined){
      if(document.querySelectorAll('.Bra__MessagesOffer').length > 0){
        document.querySelectorAll('.Bra__MessagesOffer').forEach( (target) =>{
          target.firstChild.innerHTML = `${BrasMsg}`;target.style.display = "block";
        })
      }
    }
    
  }

  const AddFreeGifts = (cart, freeGiftVariants) => {
    var variantsToAdd = [];

    freeGiftVariants.forEach((gift_variant_id) => {
      let isGiftInCart = cart.items.find(item => item.variant_id == gift_variant_id);

      if (!isGiftInCart) {
        variantsToAdd.push(gift_variant_id);
      }
    });
    
    let itemsToAdd = variantsToAdd.map((variant_id) => {
      return {
        id: variant_id,
        quantity: 1,
        properties: {
          "_auto_added": true
        }
      }
    });
    if (!itemsToAdd.length) return;

    UTILS.addItemsToCart(itemsToAdd);
  }

  const RemoveFreeGifts = (cart, freeGiftVariants) => {
    let itemsToRemove = cart.items.filter((item) => {
      return freeGiftVariants.indexOf(item.variant_id) !== -1 && item.properties.hasOwnProperty('_auto_added');
    });
    if (!itemsToRemove.length) return;

    let removeItems = {};
    itemsToRemove.forEach((item) => {
      removeItems[item.key] = 0;
    });

    UTILS.removeItemsFromCart(removeItems);
  }

  const UpdateFreeGifts = async () => {
    let cart = await UTILS.getCartJson();

    var underWearItemsInCart = GetUnderWearItemsInCart(cart);
    var isSessionDoNotAdd = sessionStorage.hasOwnProperty('donotAutoAdd');
    if (underWearItemsInCart.count >= 5) {
      if (!isSessionDoNotAdd) {
        AddFreeGifts(cart, FREE_GIFT_VARIANTS);
      }
    }
    else {
      RemoveFreeGifts(cart, FREE_GIFT_VARIANTS);
    }
  }

  const StickyATC = () => {
    let $stickyAtc = document.querySelector('#sticky-atc');
    if (!$stickyAtc) return;

    let STICKY_OFFSET = 50;
    let $btn_atc = document.querySelector('.product-single__form .add-to-cart');

    let InitStickyATC = () => {
      var intersectionObserver = new IntersectionObserver((entries) => {
        if (entries.length) {
          let isAfterForm = !entries[0].isIntersecting && entries[0].boundingClientRect.top < STICKY_OFFSET;
          $stickyAtc.classList.toggle('visible', isAfterForm);
        }
      });
      
      // start observing
      intersectionObserver.observe($btn_atc);

      document.addEventListener('variant:change', () => {
        intersectionObserver.unobserve($btn_atc);
      });
    }

    $stickyAtc.addEventListener('click', (e) => {
      e.preventDefault();
      if (e.target.classList.contains('add-to-cart')) {
        let $scrollTo = document.querySelector('.product-block--header');
        window.scrollTo({
          top: $scrollTo.offsetTop - STICKY_OFFSET,
          behavior: 'smooth'
        }); 
        document.body.classList.add('highlighted-pdp-form');
         // 3 seconds later, hide the tooltip
        setTimeout(function(){
          document.body.classList.remove('highlighted-pdp-form');
        }, 3000);
        
      }
    });

    document.addEventListener('DOMContentLoaded', InitStickyATC);
    document.addEventListener('variant:change', (e) => {
      if (e.detail.variant) {
        $stickyAtc.querySelector('.ProductMeta__Price').innerText = theme.Currency.formatMoney(e.detail.variant.price, theme.settings.moneyFormat);
      }
      InitStickyATC();
    });

    InitStickyATC();
  }

  const UpdateProductInfoOnVariantChange = () => {
    document.addEventListener('variant:change', (e) => {
      let variant = e.detail.variant;
      if(variant){
        variant.options.forEach((optionValue, optionIndex) => {
          let $optionValue = document.querySelector(`.variant__label-info[data-option="option${ (optionIndex + 1) }"] span`);
          if ($optionValue) {
            $optionValue.textContent = optionValue;
          }
        });
      }
    });
  }

  const DOMReady = () => {
    TextReadMoreLess();
    // CustomerExistsProp();
    GetSet_All_Site();
    CollectionProductCards();    
    ProductUpsells();
    InitCartGetSetUpsells();
    UpdateCartMessaging();
    StickyATC();
    Accordions();
    // UpdateFreeGifts();
    // UpdateProductInfoOnVariantChange();
    
    document.addEventListener('recommendations:loaded', CollectionProductCards);
    document.addEventListener('collection:reloaded', CollectionProductCards);
    // document.addEventListener('cart:updated', CustomerExistsProp);
    document.addEventListener('cart:updated', GetSet_All_Site);
    document.addEventListener('cart:updated', InitCartGetSetUpsells);
    document.addEventListener('cart:updated', UpdateCartMessaging);
    document.addEventListener('cart:updated', UpdateFreeGifts);
  }
  document.addEventListener('DOMContentLoaded', DOMReady);

  // functions that are not required immediately
  // window.onload = () => {
    
  //    ProductUpsells();

  //   InitCartGetSetUpsells();
  //   document.addEventListener('cart:updated', InitCartGetSetUpsells);

  //   UpdateCartMessaging();
  //   document.addEventListener('cart:updated', UpdateCartMessaging);

  //   UpdateFreeGifts();
  //   document.addEventListener('cart:updated', UpdateFreeGifts);
  // }
  
  var ua = navigator?.userAgent?.toLowerCase(); 
  ua.indexOf('safari') != -1 ? ( ua.indexOf('chrome') > -1 ? '' : document?.body?.classList.add('SafariBrowserObserver') ) : '';
  
  if( window.screen.width > 991 ){
    if ( document?.querySelector('.cv_sticky_atc_outer')?.querySelector('.ColorSwatch-slide')?.childElementCount  < 13 ){
      document?.querySelector('.cv_sticky_atc_outer')?.querySelector('.color-swatches')?.querySelectorAll('.desktopScrollArrow')?.forEach((elm)=>{
        elm?.classList.add('hide');
      })
    }
  }else if( window.screen.width > 749 && window.screen.width > 991 ){
    if ( document?.querySelector('.cv_sticky_atc_outer')?.querySelector('.ColorSwatch-slide')?.childElementCount  < 7 ){
      document?.querySelector('.cv_sticky_atc_outer')?.querySelector('.color-swatches')?.querySelectorAll('.desktopScrollArrow')?.forEach((elm)=>{
        elm?.classList.add('hide');
      })    
    }  
  }  

  document?.querySelectorAll('.upsell-form')?.forEach((elm)=>{
    elm?.querySelector('.color-swatches')?.querySelector('.variant-input-wrap')?.querySelector('.ColorSwatch-slide')?.children[0]?.classList.contains('ColorDivide') ? elm?.querySelector('.color-swatches').querySelector('.variant-input-wrap').querySelector('.ColorSwatch-slide').children[0].classList.add('hide') : '';
  })
 
})();
